import React from 'react';
import MissionsHistory from './MissionsHistory';
import RobotCleanedAreaHistory from 'components/robots/RobotCleanedAreaHistory';
import { useAppSelector } from 'store';
import { selectRobotsData } from 'store/robots/robots-slice-selectors';
import Alert from '@mui/material/Alert';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { selectOrganizationsData } from 'store/organization/organization-slice-selectors';
import { useTranslation } from 'react-i18next';
import RobotTotals from 'components/robots/RobotTotals';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';

const MissionHistoryPage: React.FC<{ dashboardPage?: boolean }> = ({ dashboardPage }) => {
  const { t } = useTranslation();

  const robotsData = useAppSelector((state) => selectRobotsData(state));
  const organizationData = useAppSelector((state) => selectOrganizationsData(state));

  const isRobotLoading =
    !dashboardPage &&
    (robotsData.rest.getRobotInformationStatus === HttpFetchStatus.Idle ||
      robotsData.rest.getRobotInformationStatus === HttpFetchStatus.Loading);
  const hasRobotFailed = !dashboardPage && robotsData.rest.getRobotInformationStatus === HttpFetchStatus.Failed;
  const isRobotAbsent = !dashboardPage && !isRobotLoading && !hasRobotFailed && robotsData.currentRobot == null;

  return (
    <Stack spacing={2} p={dashboardPage ? 1 : undefined}>
      {isRobotLoading ? (
        <React.Fragment>
          <Skeleton variant="rounded" width="100%" height={120} />
          <Skeleton variant="rounded" width="100%" height={120} />
          <Skeleton variant="rounded" width="100%" height={120} />
        </React.Fragment>
      ) : hasRobotFailed ? (
        <Alert severity="error">
          {robotsData.rest.getRobotInformationError?.message ?? t('error-loading-robot')}
        </Alert>
      ) : isRobotAbsent ? (
        <Alert severity="warning">{t('error-robot-not-found')}</Alert>
      ) : (
        robotsData.currentRobot != null && (
          <RobotTotals robotInformation={robotsData.currentRobot} />
        )
      )}

      {dashboardPage && (
        <Typography variant="h2" fontSize={24} lineHeight={2}>
          {`${organizationData.current?.name ?? ''} - ${t('button-history')}`}
        </Typography>
      )}
      {isRobotLoading ? (
        <Skeleton variant="rounded" width="100%" height={220} />
      ) : (
        !hasRobotFailed &&
        !isRobotAbsent &&
        robotsData.currentRobot != null && (
          <RobotCleanedAreaHistory robot={robotsData.currentRobot} />
        )
      )}
      <MissionsHistory />
    </Stack>
  );
};

export default MissionHistoryPage;
